export const POST_COLLECTION = "POST_COLLECTION";
export const POST_COLLECTION_SUCCESS = "POST_COLLECTION_SUCCESS";
export const POST_COLLECTION_ERROR = "POST_COLLECTION_ERROR";
export const POST_COLLECTION_CLEAR_DATA = "POST_COLLECTION_CLEAR_DATA";
